module.exports = __webpack_public_path__ + "img/xsurflog.5c452f54.png";